import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const textboxCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default textboxCommands;
